<script>
import { HorizontalBar } from "vue-chartjs";
import { setRoundedTopCornersBarChart } from "@/helpers/rounded-bar-chart";

export default {
  extends: HorizontalBar,
  props: ["gpaTops"],
  data() {
    return {
      chartData: {
        labels: [],
        datasets: [
          {
            label: "GPA datasets",
            data: [],
            backgroundColor: "#855CF8",
            borderWidth: 1,
            borderRadius: 3
          }
        ]
      },
      options: {
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
          // yAxes: [
          //   {
          //     stacked: true,
          //   },
          // ],
        },
        legend: {
          display: false
        },
        responsive: true,
        barRoundness: 1,
        cornerRadius: 20,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            title: function(tooltipItem, data) {
              return `GPA: ${data["labels"][tooltipItem[0]["index"]]}`;
            },
            label: function(tooltipItem, data) {
              const arrData = data["datasets"][0]["data"];

              const total = arrData.reduce(
                (total, curVal) => total + curVal,
                0
              );
              const percent = Math.round(
                (arrData[tooltipItem["index"]] / total) * 100
              );
              return "" + percent + " %";
            },
            afterLabel: function(tooltipItem, data) {
              return `${
                data["datasets"][0]["data"][tooltipItem["index"]]
              } students`;
            }
          },
          backgroundColor: "#FFF",
          titleFontSize: 16,
          titleFontColor: "#00072B",
          bodyFontColor: "#000",
          bodyFontSize: 14,
          displayColors: false
        }
      }
    };
  },
  methods: {
    getChartDataFrom(gpaTopsProps) {
      const labels = gpaTopsProps?.labels || [];

      const data = gpaTopsProps?.data || [];

      return {
        labels,
        data
      };
    },
    setNewChartData(gpaTopsProps) {
      const { labels, data } = this.getChartDataFrom(gpaTopsProps);
      this.chartData.labels = labels;
      this.chartData.datasets[0].data = data;
    }
  },
  mounted() {
    setRoundedTopCornersBarChart();
    this.setNewChartData(this.gpaTops);
    this.$nextTick(() => {
      this.renderChart(this.chartData, this.options);
    });
  },
  watch: {
    gpaTops: {
      deep: true,
      immediate: true,
      handler: function(newGPATops) {
        this.setNewChartData(newGPATops);
        this.$nextTick(() => {
          this.$data._chart && this.$data._chart.update();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
